import { gql } from '@apollo/client';

export default gql`
  query getOrganization {
    getOwner
  }
`;
